customElements.define(
    'section-cadeau',
    class SectionCadeau extends HTMLElement {
        constructor() {
            super();

            let selectors = {
                "optionsStep1": "#options-step-1",
                "optionsStep2": "#options-step-2",
                "optionsStep3": "#options-step-3",
                "resultsSection": ".section__cadeau--results"
            }

            this.selectors = selectors;
            this.optionsStep1 = this.querySelector(this.selectors.optionsStep1);
            this.optionsStep2 = this.querySelector(this.selectors.optionsStep2);
            this.optionsStep3 = this.querySelector(this.selectors.optionsStep3);
            this.resultsSection = this.querySelector(this.selectors.resultsSection);
            this.init();
        }

        init() {
            var self = this;

            var allSteps = [self.optionsStep1, self.optionsStep2, self.optionsStep3];
            var choosedOptiones = [];

            for (let i = 0; i < allSteps.length; i++) {
                
                allSteps[i].addEventListener('change', function(){

                    choosedOptiones = [];
                    var selectedPrice = '';

                    if (self.optionsStep1.value != "...") {
                        var step1Value = 'cadeau1_' + self.optionsStep1.value;
                        choosedOptiones.push(step1Value);
                    }
                    if (self.optionsStep2.value != "...") {
                        var step2Value = 'cadeau2_' + self.optionsStep2.value;
                        choosedOptiones.push(step2Value);
                    }
                    if (self.optionsStep3.value != "..." && self.optionsStep3.value != "peu-importe") {
                        // var step3Value = 'cadeau3_' + self.optionsStep3.value;
                        // choosedOptiones.push(step3Value);
                        selectedPrice = self.optionsStep3.value;
                        if (selectedPrice.includes('moins-de-')) {
                            selectedPrice = selectedPrice.replace('moins-de-','x < ')
                        } else if (selectedPrice.includes('plus-de-')) {
                            selectedPrice = selectedPrice.replace('plus-de-','x > ')
                        } else {
                            selectedPrice = selectedPrice.replace('de-','').replace('-a-', ' < x && x < ');
                        }

                    }

                    choosedOptiones = choosedOptiones.toString().replaceAll(',', ' AND ');
                    
                    console.log(choosedOptiones);
                    console.log(selectedPrice);

                    const query = `
                        query {
                            products(first: 250, query: "tag:${choosedOptiones}") {
                                edges {
                                    node {
                                        title
                                        vendor
                                        handle
                                        tags
                                        productType
                                        priceRange {
                                            minVariantPrice {
                                                amount
                                            }
                                            maxVariantPrice {
                                                amount
                                            }
                                        }
                                        featuredImage {
                                            url
                                            altText
                                        }
                                        variants(first:100) {
                                            edges {
                                              node {
                                                title
                                              }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `

                    const params = {
                        query : query
                    };
                
                    const optionsQuery = {
                        method: "post",
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                            "X-Shopify-Storefront-Access-Token": "b0d4fba05d4c20fa58a0fd8f1e99210f"
                        },
                        body: JSON.stringify(params)
                    };

                    return fetch(`/api/graphql`, optionsQuery)
                    .then(res => res.json())
                    .then(function(response) {

                        self.resultsSection.innerHTML = '';
                        var products = response.data.products.edges;
                        console.log(products);

                        for (let i = 0; i < products.length; i++) {
                            var product = products[i].node;
                            var productTitle = product.title;
                            var productType = product.productType;
                            var productUrl = "/products/" + product.handle;
                            var productImage = product.featuredImage.url;
                            var productImageAlt = product.featuredImage.altText;
                            var productTags = product.tags;
                            var productVariants = product.variants.edges.node;
                            var productPriceMin = product.priceRange.minVariantPrice.amount.toString();
                            var productPriceMax = product.priceRange.maxVariantPrice.amount.toString();

                            if (productPriceMin.split('.')[1].length < 2) {
                                productPriceMin = productPriceMin + '0';
                            }
                            if (productPriceMax.split('.')[1].length < 2) {
                                productPriceMax = productPriceMax + '0';
                            }
                            var minPrice = ``;
                            var tags = [];
                            if (productPriceMin < productPriceMax) {
                                minPrice = `
                                    À partir de <span class="min">${productPriceMin}€</span>
                                `
                                var promoTag = `<span class="label label--highlight">Promo</span>`
                                tags.push(promoTag);
                            }

                            productTags = productTags.toString().split(',');
                            for (let i = 0; i < productTags.length; i++) {
                                var tag = `
                                    <span class="label label--highlight">${productTags[i]}</span>
                                `
                                if (tag.includes('label__')) {
                                    tags.push(tag.replaceAll('label__', ''));
                                }
                            }

                            tags = tags.toString().replaceAll(',', ''); 

                            var productPriceEqualToCondition = eval(selectedPrice.replaceAll('x', productPriceMin));
                            if (productPriceEqualToCondition === true || typeof productPriceEqualToCondition === "undefined") {
                                const productBlock = `
                                    <div class="cadeau-product">
                                        <a class="cadeau-productimage__container" href="${productUrl}">
                                            <img class="cadeau-product-image" src="${productImage}" alt="${productImageAlt}" />
                                            <div class="cadeau-product-tags">
                                                ${tags}
                                            </div>
                                        </a>
                                        <div class="cadeau-product-info">
                                            <p class="cadeau-product-type">${productType}</p>
                                            <a href="${productUrl}" class="cadeau-product-title">${productTitle}</a>
                                            <div class="cadeau-product-price">
                                                ${minPrice}
                                                <span class="max">${productPriceMax}€</span>
                                            </div>
                                        </div>
                                    </div>
                                `
                                self.resultsSection.insertAdjacentHTML( 'beforeend', productBlock );
                            }
                        }
                            
                    });
                    
                })
            }
        }
    }
)